import { ObjectionList } from "./ObjectionList";

export function CertificationFormQuestions({
  form,
  setForm,
  categories,
  callFlowDisabled = false,
}: {
  form: any;
  setForm: (form: any) => void;
  categories: any[];
  callFlowDisabled?: boolean;
}) {
  return (
    <div className="border border-lightGray rounded-[16px] p-3 bg-white">

      <ObjectionList
        callFlow={form.callFlow}
        certificationId={form.certificationId}
        categories={categories}
        disabled={callFlowDisabled}
        onChange={(callFlow) => {
          setForm((prev) => ({
            ...prev,
            callFlow,
          }));
        }}
      />
    </div>
  );
}